module.exports = __webpack_public_path__ + "static/media/closeHbar.0dea6a80.png";